<div class="chart-container" [nbSpinner]="isLoading">
  <div
    echarts
    [options]="chartOption"
    [autoResize]="true"
    (chartInit)="onChartInit($event)"
    theme="alphabees"
    class="chart"
    style="height: 300px"
  ></div>
</div>
